/* eslint-disable class-methods-use-this */
/* global logger */
const moment = require('moment');
const formating = require('./formating');
const { MomentInitializer } = require('pando-holiday-lib');

const { isEmpty } = require('lodash');

const {
  orderType: OrderType,
  TransitDelayFactor,
} = require('pando-constants');
const Helper = require('./utils/helper');

const IST_OFFSET = 3600000 * 5.5;

class TransitDelay {
  calculateTransitDelaysDays(data, depotCalenderMap) {
    let days = 0;
    const logMessages = [{ depotCalenderMap }];
    if (data.orderType !== OrderType.OPEN) {
      let dispatchedAt;
      if (data.sla.detention.actualDetentionWindowByDepot
        && !isEmpty(data.sla.detention.actualDetentionWindowByDepot)) {
        const actualDetentions = Object.values(data.sla.detention.actualDetentionWindowByDepot);
        const lastDepotDetention = actualDetentions.reduce((d1, d2) =>
          (Date.parse(d2.endedAt) > Date.parse(d1.endedAt) ? d2 : d1));
        dispatchedAt = lastDepotDetention.endedAt && (moment(moment(
          new Date(lastDepotDetention.endedAt).getTime() + IST_OFFSET).format('YYYY-MM-DD')));
      }
      const delayDays = data.destinations.map((destination) => {
        const logMessage = {
          destinationLocation: destination.locationId,
        };
        let expectedTransitTime = destination.transitTime;
        const destDepotHolidays = depotCalenderMap ? depotCalenderMap[`${destination.locationId}`] : {};
        const momentBusinessDays = MomentInitializer.getHolidayAdjustedCalendar(destDepotHolidays);
        const deliveredAt = moment(moment(
          new Date(destination.reportedAt).getTime() + IST_OFFSET).format('YYYY-MM-DD'));
        const previousDay = moment(deliveredAt).subtract(1, 'days').startOf('day');
        logMessage.dispatchedAt = dispatchedAt;
        logMessage.deliveredAt = deliveredAt;
        logMessage.previousDay = previousDay;
        logMessage.expectedTransitTime = expectedTransitTime;
        if (!momentBusinessDays.isBusinessDay(previousDay)) {
          const prevBusinessDay = momentBusinessDays.prevBusinessDay(previousDay.clone()).startOf('day');
          logMessage.prevBusinessDay = prevBusinessDay;
          const diffdays = previousDay.diff(prevBusinessDay, 'days');
          logMessage.diffdays = diffdays;
          expectedTransitTime += diffdays;
        }
        logMessage.expectedTransitTime = expectedTransitTime;
        const transitDelayDays =
          ((dispatchedAt && deliveredAt.diff(dispatchedAt, 'days')) || 0) - expectedTransitTime;
        logMessage.transitDelayDays = transitDelayDays;
        logMessages.push(logMessage);
        return transitDelayDays < 0 ? 0 : transitDelayDays;
      });
      logMessages.push({ delayDays });
      days = Math.max(...delayDays);
    }
    logMessages.push({ orderNo: data.orderNo, maxDay: days });
    logger.info(`transit delay calculation logs - ${data.orderNo} - ${JSON.stringify(logMessages)}`);
    return days;
  }
  calculateDelayCharges(charges, days) {
    let transitDelayCost = 0;
    let transitDelayDays = days;
    for (let chargeIndex = 0; chargeIndex < charges.length && transitDelayDays && transitDelayDays > 0;
      transitDelayDays -= 1, chargeIndex += 1) {
      transitDelayCost += charges[chargeIndex];
    }

    // If number of transit delay exceeds 6 days, add day 6th delay charge to transit delay cost based on remaining transit delay days
    if (transitDelayDays > 0) {
      transitDelayCost += charges[charges.length - 1] * (transitDelayDays);
    }
    return transitDelayCost;
  }

  calculateChargeByPercentage(charges, freightCharge, days) {
    let transitDelayCost = 0;
    let transitDelayDays = days;
    for (let chargeIndex = 0; chargeIndex < charges.length && transitDelayDays;
      transitDelayDays -= 1, chargeIndex += 1) {
      const chargePercentage = charges[chargeIndex];
      transitDelayCost += ((chargePercentage / 100) * freightCharge);
    }

    // If number of transit delay exceeds 6 days,
    // Using day 6th delay charge percentage for remaining transit delay days
    if (transitDelayDays > 0) {
      const chargePercentage = charges[charges.length - 1];
      transitDelayCost += ((chargePercentage / 100) * freightCharge * transitDelayDays);
    }
    return transitDelayCost;
  }

  calculateDetentionCharges(data, freightCharge, depotCalenderMap) {
    let result = 0;
    if (data.orderType !== OrderType.OPEN) {
      const days = this.calculateTransitDelaysDays(data, depotCalenderMap);
      let charges = 0;
      const detentionCharge = Helper.getDetentionCharge(data);
      const transitDelayCharge = (detentionCharge && detentionCharge.delay) || [0];
      const transitDelayFactor = (detentionCharge && detentionCharge.transit_delay_factor) || TransitDelayFactor.ABSOLUTE;
      if (transitDelayFactor === TransitDelayFactor.ABSOLUTE) {
        charges = this.calculateDelayCharges(transitDelayCharge, days);
      } else if (transitDelayFactor === TransitDelayFactor.PERCENTAGE) {
        charges = this.calculateChargeByPercentage(transitDelayCharge, freightCharge, days);
      }
      result = formating.formatWithPaymentField(charges.toFixed(2));
    }
    return result;
  }

  calculateDetentionDays(data, depotCalenderMap) {
    let days = 0;
    if (data.orderType !== OrderType.OPEN) {
      days = this.calculateTransitDelaysDays(data, depotCalenderMap);
    }
    return days;
  }

  transitDelayByTransporterPerformance(data, freightCharge, depotCalenderMap) {
    return 0;
  }
}

module.exports = TransitDelay;
